import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import {Router, ActivatedRoute,} from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";  
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { MustMatch } from '../helper.service';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  
  constructor(private router: Router ,private user:UserService,private Router: ActivatedRoute, private SpinnerService: NgxSpinnerService, private route: ActivatedRoute,private formBuilder: FormBuilder) { 

    var nu_first_name = localStorage.getItem('nu_first_name');
    if(nu_first_name !== null){
      this.router.navigate(['/dashboard']);
    }
    this.user.checkPasswordToken(this.token_id).subscribe(
  	  resp => {
        if(resp.status == '3'){
          this.router.navigate(['/login']);
        }
        else{
          this.user_id = resp.user_id;
          //console.log(resp);
          this.SpinnerService.hide();
          this.showData = true;
          localStorage.setItem('user_id', resp.user_id);
        }
  		}
  	); 
  }
  confirmPasswordMsg= '';
  user_id = '';
  token_id =  this.route.snapshot.params['id'];
  showData = false;
  passwordFormSubmit = false;
  validPassword = false;
  validPasswordMsg = '';
  ngOnInit(): void {
    
    document.body.classList.add('bluebaground');
    
  }

  emailError:string = '';
  passwordError:string = '';

  reset_password_form = new FormGroup({
    password: new FormControl('', [Validators.required]),
    confirm_password: new FormControl('', [Validators.required]),
  });
  
  /* reset_password_form = this.formBuilder.group({
    password: ['', [Validators.required, Validators.minLength(6)]],
    confirm_password: ['', Validators.required]
  }, {
      validator: MustMatch('password', 'confirmPassword')
  }); */
  
  get reset_password_f(){
    return this.reset_password_form.controls;
  }
  
  reset_password_submit(){
    this.passwordFormSubmit = true;
    this.SpinnerService.show();
    if(this.reset_password_form.invalid){
      this.SpinnerService.hide();
      return;
    }
    const password = this.reset_password_form.value.password;
    const confirm_password = this.reset_password_form.value.confirm_password;
    if(password != confirm_password){
      this.confirmPasswordMsg = 'Passwords must match';
      this.SpinnerService.hide();
      return false;
    }
    this.user.passwordReset(password, confirm_password).subscribe(res => {
      if(res.status == '2'){
        this.confirmPasswordMsg = res.validationErrors.confirmPassword;
      }
      if(res.status == '1'){
        this.confirmPasswordMsg = res.message;
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 2000);
      }
    });
    //console.log(this.reset_password_form.value);
  }

  ngOnDestroy(): void {
    document.body.classList.remove('bluebaground');
  }
  enterPassword(event){
    //console.log(event);
    var res;
    var str = event;
    if(event != ''){
      if (str.match( 
          /[0-9]/g) && str.match( 
          /[^a-zA-Z\d]/g) && str.length >= 8) {
        res = "TRUE"; 
        this.validPassword = true;
        this.validPasswordMsg = '';
      }
      else {
        this.validPasswordMsg = 'Password must contain minimum 8 characters, 1 number, 1 alphabet and 1 special character';
        res = "FALSE";
        this.validPassword = false;
      }
    }
    //console.log(res);
    }
    confirmPassword(){
      this.confirmPasswordMsg = '';
    }
}
